import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/carousel.css';
import {Carousel} from 'react-responsive-carousel';


export default function Amazon() {

    return (
        <div>
            <div>
                <Carousel dynamicHeight showArrows={false} showStatus={false} className="presentation-mode" showThumbs={false} autoPlay
                          interval={5000} infiniteLoop >
                    <div>
                        <img alt="Hector at Amazon Badge" className="image" src="assets/amazon/1.png"/>
                    </div>
                    <div>
                        <img alt="Hector at Amazon Spheres" className="image" src="assets/amazon/2.png"/>
                    </div>
                    <div>
                        <img alt="Hevtor at Amazon Analyticon" className="image" src="assets/amazon/3.png"/>
                    </div>
                    <div>
                        <img alt="Hector at Amazon Rolling Stone Celebration" className="image" src="assets/amazon/4.png"/>
                    </div>
                </Carousel>
            </div>
            <div className="content">
                <h1>Learning About Customer Obsession</h1>
                <p>I joined Amazon in June 2019 to work as a Senior Techical Program Manager in the Big Data Technologies (BDT) team. The team creates systems that are used to manage hexabytes of data. From compaction and conversion services to Single-Page Web Apps that are used to make sense of so much data.  </p>
                <p>The BDT Team recently completed the Rolling Stone project. An effort to migrate all Oracle databases to use AWS offerings. This offers many benefits, like, Cost Reduction, Performance Improvements and Administrative Overhead reduction. </p>
                <p>Currently, I am running the Reliability initiative, aimed at improving our offerings in services to increase our service-level objectives.</p>
            </div>
        </div>
    );

}


// WEBPACK FOOTER //
// ./src/components/sections/Amazon.jsx